export default "__VITE_ASSET__bd7be3c7__"